import {
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
  // DP
  ELEMENT_TYPE_DP_ATL,
  ELEMENT_TYPE_DP_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_LEARNER_PROFILE,
  ELEMENT_TYPE_DP_OBJECTIVES,
  ELEMENT_TYPE_DP_AIM,
  ELEMENT_TYPE_DP_SYLLABUS,
  // MYP
  ELEMENT_TYPE_MYP_ATL,
  ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  ELEMENT_TYPE_MYP_LEARNER_PROFILE,
  ELEMENT_TYPE_MYP_KEY_CONCEPT,
  PLANNER_ELEMENT_MYP_GLOBAL_CONTEXT,
  ELEMENT_TYPE_MYP_RELATED_CONCEPT,
  ELEMENT_TYPE_MYP_OBJECTIVES,
  // PYP
  ELEMENT_TYPE_PYP_ATL,
  ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  ELEMENT_TYPE_PYP_LEARNER_PROFILE,
  ELEMENT_TYPE_PYP_KEY_CONCEPT,
  ELEMENT_TYPE_PYP_FOCUS_AREA,
  // UBD,
  ELEMENT_TYPE_UBD_ATL,
  ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ELEMENT_TYPE_MYP_SPECIFIED_CONCEPT,
} from "Constants/stringConstants";

import {
  AtlDuotone,
  KeyConceptDuotone,
  ObjectivesDuotone,
  RelatedConceptsDuotone,
  DifferentiationDuotone,
  KeyRelatedConceptsDuotone,
  LearnerProfileDuotone,
  ThemeDescriptorInsightsDuotone,
  TransdisciplinaryThemeDuotone,
  GlobalContextDuotone,
  HorizontalViewKcDuotone,
} from "@toddle-edu/ds-icons";

export const INSIGHT_VIEWS = {
  OVERALL_INSIGHTS: "OVERALL_INSIGHTS",
  VERTICAL_INSIGHTS: "VERTICAL_INSIGHTS",
  GRADE_VIEW: "GRADE_VIEW",
  SUBJECT_VIEW: "SUBJECT_VIEW",
  DEPARTMENT_VIEW: "DEPARTMENT_VIEW",
  COURSE_VIEW: "COURSE_VIEW",
  CLASS_VIEW: "CLASS_VIEW",
  HORIZONTAL_VIEW: "HORIZONTAL_VIEW",
  STUDENT_VIEW: "STUDENT_VIEW",
};

export const CURRICULUM_ELEMENT_TYPE_MAP = {
  ATL: {
    [CURRICULUM_TYPE_PYP]: ELEMENT_TYPE_PYP_ATL,
    [CURRICULUM_TYPE_UBD]: ELEMENT_TYPE_UBD_ATL,
    [CURRICULUM_TYPE_MYP]: ELEMENT_TYPE_MYP_ATL,
    [CURRICULUM_TYPE_DP]: ELEMENT_TYPE_DP_ATL,
  },
  STANDARD: {
    [CURRICULUM_TYPE_PYP]: ELEMENT_TYPE_PYP_LEARNING_STANDARD,
    [CURRICULUM_TYPE_UBD]: ELEMENT_TYPE_UBD_LEARNING_STANDARD,
    [CURRICULUM_TYPE_MYP]: ELEMENT_TYPE_MYP_LEARNING_STANDARD,
    [CURRICULUM_TYPE_DP]: ELEMENT_TYPE_DP_LEARNING_STANDARD,
  },
  LPA: {
    [CURRICULUM_TYPE_PYP]: ELEMENT_TYPE_PYP_LEARNER_PROFILE,
    [CURRICULUM_TYPE_MYP]: ELEMENT_TYPE_MYP_LEARNER_PROFILE,
    [CURRICULUM_TYPE_DP]: ELEMENT_TYPE_DP_LEARNER_PROFILE,
  },
  KEY_CONCEPT: {
    [CURRICULUM_TYPE_PYP]: ELEMENT_TYPE_PYP_KEY_CONCEPT,
    [CURRICULUM_TYPE_MYP]: ELEMENT_TYPE_MYP_KEY_CONCEPT,
  },
  FOCUS_AREA: {
    [CURRICULUM_TYPE_PYP]: ELEMENT_TYPE_PYP_FOCUS_AREA,
  },
  RELATED_CONCEPT: {
    [CURRICULUM_TYPE_MYP]: ELEMENT_TYPE_MYP_RELATED_CONCEPT,
  },
  GLOBAL_CONTEXT: {
    [CURRICULUM_TYPE_MYP]: PLANNER_ELEMENT_MYP_GLOBAL_CONTEXT,
  },
  OBJECTIVE: {
    [CURRICULUM_TYPE_MYP]: ELEMENT_TYPE_MYP_OBJECTIVES,
    [CURRICULUM_TYPE_DP]: ELEMENT_TYPE_DP_OBJECTIVES,
  },
  AIM: {
    [CURRICULUM_TYPE_DP]: ELEMENT_TYPE_DP_AIM,
  },
  SYLLABUS: {
    [CURRICULUM_TYPE_DP]: ELEMENT_TYPE_DP_SYLLABUS,
  },
};

export const VIEW_ENTITY_MAP = {
  [INSIGHT_VIEWS.VERTICAL_INSIGHTS]: "OVERALL",
  [INSIGHT_VIEWS.SUBJECT_VIEW]: "SUBJECT",
  [INSIGHT_VIEWS.DEPARTMENT_VIEW]: "DEPARTMENT",
  [INSIGHT_VIEWS.GRADE_VIEW]: "GRADE",
  [INSIGHT_VIEWS.HORIZONTAL_VIEW]: "GRADE",
  [INSIGHT_VIEWS.COURSE_VIEW]: "LEARNING_COURSE",
  [INSIGHT_VIEWS.CLASS_VIEW]: "CLASS",
  [INSIGHT_VIEWS.STUDENT_VIEW]: "STUDENT",
};

export const ELEMENTS_WITH_TASK_COUNT_MAP = {
  [CURRICULUM_TYPE_PYP]: [
    ELEMENT_TYPE_PYP_ATL,
    ELEMENT_TYPE_PYP_KEY_CONCEPT,
    ELEMENT_TYPE_PYP_LEARNER_PROFILE,
  ],
  [CURRICULUM_TYPE_UBD]: [ELEMENT_TYPE_UBD_ATL],
  [CURRICULUM_TYPE_MYP]: [
    ELEMENT_TYPE_MYP_OBJECTIVES,
    ELEMENT_TYPE_MYP_ATL,
    ELEMENT_TYPE_MYP_KEY_CONCEPT,
    ELEMENT_TYPE_MYP_RELATED_CONCEPT,
    ELEMENT_TYPE_MYP_LEARNER_PROFILE,
    ELEMENT_TYPE_MYP_SPECIFIED_CONCEPT,
  ],
  [CURRICULUM_TYPE_DP]: [
    ELEMENT_TYPE_DP_LEARNER_PROFILE,
    ELEMENT_TYPE_DP_SYLLABUS,
    ELEMENT_TYPE_DP_ATL,
  ],
};

export const PLANNER_ELEMENT_ICONS = [
  HorizontalViewKcDuotone,
  TransdisciplinaryThemeDuotone,
  RelatedConceptsDuotone,
  KeyRelatedConceptsDuotone,
  DifferentiationDuotone,
];

export const ELEMENT_TYPE_ICON_MAP = {
  ATL: AtlDuotone,
  LPA: LearnerProfileDuotone,
  KEY_CONCEPT: KeyConceptDuotone,
  THEME: ThemeDescriptorInsightsDuotone,
  FOCUS_AREA: ThemeDescriptorInsightsDuotone,
  RELATED_CONCEPT: RelatedConceptsDuotone,
  OBJECTIVE: ObjectivesDuotone,
  GLOBAL_CONTEXT: GlobalContextDuotone,
};

export const DEFAULT_SELECTED_ENTITY = "COURSE";

export const MANAGE_OPTION_KEY = "MANAGE";

export const CONNECTION_ELEMENT_TYPES = [
  "DP_METACOGNITION_APPROACH",
  "DP_DIFFERENTIATION_APPROACH",
  "DP_LANGUAGE_AND_LEARNING_CONNECTION",
  "DP_TOK_CONNECTION",
  "DP_CAS_STRANDS",
  "DP_ATL",
];

export const CONNECTION_ELEMENT_TITLES = {
  DP_ATL: "planningInsights:atl_connections",
  DP_METACOGNITION_APPROACH: "planningInsights:metacogntion",
  DP_DIFFERENTIATION_APPROACH: "planningInsights:differentiation",
  DP_LANGUAGE_AND_LEARNING_CONNECTION: "planningInsights:language_and_learning",
  DP_TOK_CONNECTION: "planningInsights:tok_connections",
  DP_CAS_STRANDS: "planningInsights:cas_connections",
};

export const MORE_ITEM_TOOLTIP_TRIGGER = ["focus", "hover"];
